<template>
  <div
    class="
      d-flex
      flex-row flex-nowrap flex
      align-center
      justify-end
      flex-grow-0
    "
  >
    <v-btn
      :class="styleFormatOdd === 'flex-row' ? 'primary--text' : ''"
      text
      small
      @click="styleFlexWrapOdds('flex-row')"
    >
      <v-icon>mdi-grid</v-icon>
    </v-btn>
    <v-btn
      :class="styleFormatOdd === 'flex-column' ? 'primary--text' : ''"
      text
      small
      @click="styleFlexWrapOdds('flex-column')"
    >
      <v-icon>mdi-table-of-contents</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toggle_exclusive: false,
    };
  },

  created() {
    const verticalOdds = ["esportenet", "pagamaissports"];

    if (verticalOdds.includes(this.$domain())) {
      this.styleFlexWrapOdds("flex-column");
    }
  },

  computed: {
    // Recupera Style Format Odd para setar a class "active"
    styleFormatOdd: function() {
      return this.$store.state.styleFlexWrapOdds;
    },
  },
  methods: {
    styleFlexWrapOdds(type) {
      this.$store.commit("setStyleFlexWrapOdds", type);
    },
  },
};
</script>
